import { TFunction } from "react-i18next";
import * as yup from "yup";
import { FormValues } from "./interfaces";

export const OTP_CODE_LENGTH = 6;
export const OTP_CODE_EXPIRATION_TIME = 300; // 5 minutes in seconds

export const initialValues: FormValues = {
  code: undefined,
};

export const getValidationSchema = (t: TFunction): yup.SchemaOf<FormValues> =>
  yup.object().shape({
    code: yup
      .number()
      .required(t("7893") /* O campo deverá ser preenchido */)
      .test(
        "exactLength",
        t("11881", {
          length: OTP_CODE_LENGTH,
        }) /* Deverá ter exatamente {{length}} caracteres */,
        (value) => (value ? value.toString().length === OTP_CODE_LENGTH : false)
      ),
  });
